import React from 'react';

// components
import WpBadge from 'Wpds/components/badge/WpBadge';

// Types
import { Type } from 'Shared/types/Capture.types';

type Props = {
  surfaceItem;
};

const SurfaceItemStatus = ({ surfaceItem }: Props) => {
  if (!surfaceItem.status) return null;

  const getBadgeColorForJiraIssue = () => {
    switch (surfaceItem.status_category) {
      case 'indeterminate':
        return 'blue';
      case 'done':
        return 'green';
      default:
        return 'gray';
    }
  };

  const getBadgeColorForAsanaTask = () => {
    switch (surfaceItem.status) {
      case 'Complete':
        return 'green';
      default:
        return 'gray';
    }
  };

  const getBadgeColor = () => {
    switch (surfaceItem.type) {
      case Type.ASANA:
        return getBadgeColorForAsanaTask();
      case Type.JIRA:
        return getBadgeColorForJiraIssue();
      default:
        return 'gray';
    }
  };

  return <WpBadge color={getBadgeColor()}>{surfaceItem.status}</WpBadge>;
};

export default SurfaceItemStatus;
